import AddIcon from '@mui/icons-material/Add';
import { Button as ButtonMaterial, FormControl, FormHelperText, Input, InputAdornment, InputLabel, LinearProgress } from '@mui/material';
import ptBR from 'date-fns/locale/pt-BR';
import moment from "moment";
import { useEffect,  useState } from "react";
import { Button, Card, Col, Container, Image, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { FaEdit, FaShip, FaSpinner, FaTrash, FaTripadvisor } from "react-icons/fa";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PickerButtom } from "../../components/sub-render.component";
import { useAlertMessageContext } from "../../contexts/alert-message.context";
import { useDeleteMessageContext } from "../../contexts/delete-message.context";
import authService from "../../services/auth.service";
import dlvService from "../../services/dlv.service";
import { arrivalForecast, dateToString, notNullToDate, toDate, toInt, toString, toStringFloat } from "../../utilities/auxiliary-functions";
import { PermissionEnum,  VESSEL_LANCHA } from "../../utilities/constants";
import { removeFormatDate } from "../../utilities/masks";
import { AlertMessageEnum, EDeliveryStatus, getDeliveryStatus, getVesselStatus } from "../../utilities/types";
import { isEmpty } from "../../utilities/validators";
import OperationHeader from "../headers/operation.header";
// import DeliveryCadastreModal from "../modals/delivery.cadastre.modal";
import Jet from '../../assets/images/Jetski.svg';
import Lancha from '../../assets/images/Lancha.svg';
import SearchIcon from '@mui/icons-material/Search';
import styles from './delivery.operation.module.scss';
import { DataGrid, GridColDef, GridEventListener, GridSelectionModel, GridToolbar } from '@mui/x-data-grid';
import { ThemeProvider } from '@mui/material/styles';
import theme from "../../theme";
import { TFilter } from '../../types/FilterType';
import cduService from '../../services/cdu.service';
import { useTranslateContext } from '../../contexts/translate.context';
import { usePartnerContext } from '../../contexts/partner.context';
import DeliveryCadastreModal from '../modals/delivery.cadastre.modal';
import lclService from '../../services/lcl.service';
import { useConfirmMessageContext } from '../../contexts/confirm-message.context';

export interface IDeliveryOperationProps {
    viewOnly?: boolean
}

export const DeliveryOperation: React.FC<IDeliveryOperationProps> = (props: IDeliveryOperationProps) => {
    
    const navigator = useNavigate();
    
    const alertContext = useAlertMessageContext();
    const deleteContext = useDeleteMessageContext();
    const confirmContext = useConfirmMessageContext();
    const { display } = useTranslateContext();
    let { partner } = usePartnerContext();

    const title = display.title.delivery;
    const description = '';

    const [ dateTimeStart, setDateTimeStart ] = useState(dateToString(new Date(), 'dd/mm/yyyy') + ' 00:00:00');
    const [ dateTimeEnd, setDateTimeEnd ] = useState(dateToString(new Date(), 'dd/mm/yyyy') + ' 23:59:59');
    
    let reloadPage = false;
    const [ isLoading, setLoading ] = useState(false);
    const [ textSearch, setTextSearch ] = useState('');
    const [ showFilter, setShowFilter]  = useState(false);
    const [ sending, setSending ] = useState(false);
    const [ selectionModel, setSelectionModel ] = useState<GridSelectionModel>([]);

    let noPaged = true;
    const [ searchParams, setSearchParams ] = useSearchParams();

    const [ pageSize, setPageSize ] = useState(10);
    const [ page, setPage ] = useState(0);
    const [ pageFilled, setPageFilled ] = useState<number[]>([]);

    const [ recordCount, setRecordCount ] = useState(0);
    const [ records, setRecords ] = useState([] as any);
    const [ originalRecords, setOriginalRecords ] = useState([] as any);

    const columns: GridColDef[] = [
        { field: 'launch', headerName: display.label.date_launch, width: 130, align: 'center', headerAlign: 'center', renderCell: getLaunch },
        { field: 'applicant', headerName: display.label.applicant, minWidth: 300, flex: 1, align: 'left', headerAlign: 'center', renderCell: getApplicant },
        { field: 'status', headerName: display.label.status, width: 100, flex: 0.5, align: 'center', headerAlign: 'center', renderCell: getStatus },
        { field: 'payment', headerName: display.label.payment, width: 100, flex: 0.5, align: 'center', headerAlign: 'center', valueGetter: getPayment },
        { field: 'quantity', headerName: display.label.qty, width: 70, align: 'right', headerAlign: 'center' },
        { field: 'amount', headerName: display.label.amount, width: 100, align: 'right', headerAlign: 'center', valueGetter: getAmount },
        { field: 'operator', headerName: display.label.operator, minWidth: 150, flex: 0.5, align: 'center', headerAlign: 'center' },
        {
            field: 'action',
            headerName: display.label.actions,
            headerAlign: 'center',
            renderCell: renderButtons,
            disableExport: true,
        }
    ];
    
    function getLaunch(param: any) {
        const delivery = param.row;
        // return dateToString(delivery.launch, 'dd/mm/yyyy HH:MM:ss');
        
        return (
            <div className={`${styles.info} d-flex flex-column align-items-center justify-content-center`}>
                <div className={`mt-2 ${styles.info}`}>{new Date(delivery.launch).toLocaleDateString('pt-BR')}</div>
                <div className={`mt-1 ${styles.info}`}>{new Date(delivery.launch).toLocaleTimeString('pt-BR')}</div>
            </div>
        )
    }

    function getApplicant(param: any) {
        const { vessel, movement } = param.row;
        
        if (vessel) {
            return (
                <div style={{ width: '100%', display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between'}}>
                    <div><FaShip size={23} /></div>
                    <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center', justifyContent: 'space-around'}}>
                        <div>{vessel.name}<br/>{vessel.identifyKey}</div>
                        <div>
                            {toInt(vessel.typeVessel) === VESSEL_LANCHA ? (
                                <div className="d-flex flex-column align-items-center justify-content-center mb-2">
                                    <div className="mt-2 d-flex justify-content-center mb-2">
                                        <Image src={Lancha} className="jet" style={{height: 32}}/>
                                        <small className="ms-2">{`${(vessel.vesselSize) ? vessel.vesselSize : '-'}'`}</small>
                                    </div>
                                    <span className={styles.vesselColor} style={{backgroundColor: `${vessel.color}`}}></span>
                                </div>
                            ):(
                                <div className="d-flex flex-column align-items-center justify-content-center mb-2">
                                    <div className="d-flex justify-content-center mb-2">
                                        <Image src={Jet} className="jet mt-3" style={{height: 32}}/>
                                        <small className="ms-1 mt-3">{`10'`}</small>
                                    </div>
                                    <span className={styles.vesselColor} style={{backgroundColor: `${vessel.color}`}}></span>
                                </div>
                            )}
                        </div>
                        <div className="d-flex flex-column align-items-center justify-content-center">
                            <div>{vessel.brand}</div>
                            <div>{vessel.model}</div>
                        </div>
                        <div className="d-flex flex-column align-items-center justify-content-center">
                            <div>{movement.locator}</div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return <div>{param.applicant}</div>
        }
    }

    function getStatus(param: any) {
        const delivery = param.row;
        
        return (
            <div className="mt-0 d-flex flex-column align-items-center" style={{ width: '100%' }}>
                <span className={`${styles.number} ${delivery.id} `}>{delivery.id}</span>
                <span className={`${styles.orderStatus} mt-1 mb-1 ${toInt(delivery.status) === EDeliveryStatus.PENDING ? styles.pending : toInt(delivery.status) === EDeliveryStatus.CANCELED ? styles.canceled : toInt(delivery.status) === EDeliveryStatus.FINISHED ? styles.finished : styles.requested}`}>
                    {getDeliveryStatus(toInt(delivery.status))}
                </span>
            </div>
        )
    }

    function getPayment(param: any) {
        const delivery = param.row;
        return delivery.payment === 'MONTHLY' ? 'Mensalista' : delivery.payment === 'SINGLE' ? 'Avulso' : '-';
    }

    function getAmount(param: any) {
        const delivery = param.row;
        return toStringFloat(delivery.amount);
    }

    function renderButtons(param: any) {
        let deliveryRows = [] as any;
        const originals = param.row;
        for (var o = 0; o < originals.length; o++) {
            deliveryRows[deliveryRows.length] = originals[o].original;
        }
        const deliveryRow = param.row;

        return (
            <div className="d-flex w-100 justify-content-center gap-2">
                {authService.hasPermission(PermissionEnum.OPERATION_DELIVERY_EDIT) && 
                <>
                    <OverlayTrigger overlay={<Tooltip id="tooltip">{display.tooltips.toEdit}</Tooltip>}>
                        <span onClick={(e) => onClick_AdvanceDelivery(e, deliveryRow)}>
                            <FaTripadvisor size={18} />
                        </span>
                    </OverlayTrigger>
                    <OverlayTrigger overlay={<Tooltip id="tooltip">{display.tooltips.toEdit}</Tooltip>}>
                        <span onClick={(e) => onClick_EditDelivery(e, deliveryRow)}>
                            <FaEdit size={18} />
                        </span>
                    </OverlayTrigger>
                </>
                }
                {authService.hasPermission(PermissionEnum.OPERATION_DELIVERY_REMOVE) && 
                    <OverlayTrigger overlay={<Tooltip id="tooltip">{display.tooltips.delete}</Tooltip>}>
                        <span onClick={(e) => onClick_DeleteDelivery(e, deliveryRows, deliveryRow)}>
                            <FaTrash size={18} />
                        </span>
                    </OverlayTrigger>
                }
            </div>
        );
    }
    
    const [ deliveryId, setDeliveryId ] = useState('');
    const [ delivery, setDelivery ] = useState({} as any);
    const [ isEditDelivery, setEditDelivery ] = useState(false);
    const [ showDelivery, setShowDelivery ] = useState(false);

    const onChange_DateTimeStart = async (date: any) => {
        const dateStop = toDate(dateTimeEnd, 'dd/mm/yyyy HH:MM:ss');
        if (date > dateStop) {
            setDateTimeStart(dateToString(dateStop, 'dd/mm/yyyy') + ' 00:00:00');
        } else {
            setDateTimeStart(dateToString(date, 'dd/mm/yyyy HH:MM:ss'));

            let parameterMaximumDaysInConsultations = await cduService.parameterByCode(partner.companyId, '10');
            let fim = moment(date).day(toInt(parameterMaximumDaysInConsultations.content) + 1);
            setDateTimeEnd(fim.format('DD/MM/YYYY 23:59:59'));
        }

        setRecords([]);
        setOriginalRecords([]);
        setRecordCount(0);
        setPageFilled([]);
    }

    const onChange_DateTimeStop = (date: any) => {
        const dateStart = toDate(dateTimeStart, 'dd/mm/yyyy HH:MM:ss');
        if (date < dateStart) {
            setDateTimeEnd(dateToString(dateStart, 'dd/mm/yyyy') + ' 23:59:59');
        } else {
            setDateTimeEnd(dateToString(date, 'dd/mm/yyyy HH:MM:ss'));
        }

        setRecords([]);
        setOriginalRecords([]);
        setRecordCount(0);
        setPageFilled([]);
    }
    
    function onClick_RefreshDelivery(event: any) {
        event.preventDefault();
        
        setSending(true);
        searchFilter(dateTimeStart, dateTimeEnd);
    } // onClick_RefreshDelivery
    
    function onClick_AddRecord(event: any) {
        event.preventDefault();

        setEditDelivery(false);
        setDeliveryId('new');
        setDelivery({} as any);
        setShowDelivery(true);
    } // onClick_AddRecord

    function onClick_EditDelivery(event: any, delivery: any) {
        event.preventDefault();

        setEditDelivery(true);
        setDeliveryId(delivery.id);
        setDelivery(delivery);
        setShowDelivery(true);
    } // onClick_EditRecord

    async function onClick_DeleteDelivery(event: any, records: any, record: any) {
        event.preventDefault();
        const isConfirmed = await deleteContext.show(title, display.message.delete_record, true);
        if (isConfirmed && isConfirmed.result) {
            try {
                await dlvService.deliverDeleteById(record.id, isConfirmed.message);
                searchFilter(dateTimeStart, dateTimeEnd);
            } catch(error: any) {
                await alertContext.show(AlertMessageEnum.FAIL, title, error);
            }
        }
    } // onClick_DeleteRecord

    async function onClick_AdvanceDelivery(event: any, delivery: any) {
        event.preventDefault();
        const isConfirmed = await confirmContext.show(title, 'Confirmar atendimento ?');
        if (isConfirmed) {
            let status = toInt(delivery.status) + 1;
            if (status > EDeliveryStatus.CANCELED)
                status = EDeliveryStatus.REQUESTED;

            const resultDeliver = await dlvService.advanceStatus(delivery.id, status);
            const deliverList = originalRecords.map((deliver: any, index: number) => {
                if (resultDeliver.id === deliver.id)
                    deliver.status = resultDeliver.status;
                return deliver;
            });
            setRecords(deliverList);
        }
    } // onClick_AdvanceDelivery

    async function searchFilter(dateTimeStart: string, dateTimeEnd: string) {
        setLoading(true);

        /* Sempre incluir o partner na pesquisa */
        if (!isEmpty(partner)) {
            try {
                setDateTimeStart(dateTimeStart);
                setDateTimeEnd(dateTimeEnd);

                let localPageSize = pageSize;
                let localPage = page;

                if (noPaged) {
                    if (searchParams.has('limit')) {
                        let paramPageSize = searchParams.get('limit');
                        if (paramPageSize) {
                            // eslint-disable-next-line react-hooks/exhaustive-deps
                            localPageSize = Number.parseInt(paramPageSize);
                            setPageSize(localPageSize);
                        }
                    }
                    if (searchParams.has('offset')) {
                        let paramPage = searchParams.get('offset');
                        if (paramPage) {
                            // eslint-disable-next-line react-hooks/exhaustive-deps
                            localPage = Number.parseInt(paramPage);
                            setPage(localPage);
                        }
                    }
                }

                if (pageFilled.indexOf(localPage) === -1) {
                    const filter = {
                        where: {
                            launch: { start: removeFormatDate(dateTimeStart), end: removeFormatDate(dateTimeEnd) }
                        },
                        order: [ [ 'launch', 'ASC' ] ],
                        limit: localPageSize, 
                        offset: localPage * localPageSize
                    } as TFilter;
                    const deliverSearch = await dlvService.deliverSearch(filter);
                    setRecordCount(deliverSearch.count);
                    const deliverList = [] as any;
                    records.forEach((record: any) => deliverList.push(record));
                    deliverSearch.rows.forEach((record: any) => deliverList.push(record));

                    for (let r = 0; r < deliverList.length; r++) {
                        const deliver = deliverList[r] as any;
                        if (deliver.applicant === 'VESSEL') {
                            deliver.vessel = await lclService.vesselById(deliver.applicantId);
                            const filterMovement = {
                                where: {
                                    dateMovement: {
                                        start: removeFormatDate(dateToString(deliver.launch, 'dd/mm/yyyy') + " 00:00:00"),
                                        end: removeFormatDate(dateToString(deliver.launch, 'dd/mm/yyyy') + " 23:59:59")
                                    },
                                    vesselId: deliver.vessel.id
                                },
                                order: [ [ 'dateMovement', 'ASC' ] ],
                            } as TFilter;
                            const resultMov = await lclService.movementVesselFilter(filterMovement);
                            deliver.movement = resultMov.rows;
                        } else if (deliver.applicant === 'MEMBER') {
                            deliver.member = await lclService.memberById(deliver.applicantId);
                        } else if (deliver.applicant === 'EMPLOYEE') {
                            deliver.employee = await cduService.employeeById(deliver.applicantId);
                        }
                    }

                    setRecords(deliverList);
                    setOriginalRecords(deliverList);
                    setSending(false);

                    if (deliverList.length > 0)
                        pageFilled.push(localPage);
                }
            } catch(error: any) {
                await alertContext.show(AlertMessageEnum.FAIL, title, error);
            } finally {
                setSending(false);
                setLoading(false);
                setShowFilter(false);
            }
        } else {
            await alertContext.show(AlertMessageEnum.FAIL, title, 'Não foi definido uma Marina para exibir o cadastro !');
            setLoading(false);
            navigator(`/portal`);
        }
    } // searchFilter

    const onChangePageSize = (newPageSize: number) => {
        setSearchParams({...searchParams, 'limit': `${newPageSize}`, 'offset': `${0}`});

        setRecords([]);
        setOriginalRecords([]);
        setRecordCount(0);
        setPageFilled([]);
        setPageSize(newPageSize);
        setPage(0);
    }
    
    const onChangePage = (newPage: number) => {
        setSearchParams({...searchParams, 'offset': `${newPage}`});

        setPage(newPage);
    }

    let effectForPage = false;

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        noPaged = false;
        let paramPage = searchParams.get('offset');
        if (paramPage) {
            searchFilter(dateTimeStart, dateTimeEnd);
            effectForPage = true;
        }
    }, [pageSize, page]); // useEffect

    useEffect(() => {
        if (!isLoading && !reloadPage) {
            if (isEmpty(partner))
                // eslint-disable-next-line react-hooks/exhaustive-deps
                partner = authService.currentPartner();

            noPaged = true;
            if (!effectForPage) {
                let inicio = moment().day(0); // domingo desta semana
                let fim = moment().day(6); // sábado desta semana

                let startDate = inicio.format('DD/MM/YYYY 00:00:00');
                let endDate = fim.format('DD/MM/YYYY 23:59:59');
                
                searchFilter(startDate, endDate);
                effectForPage = false;
            }
        }

        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            reloadPage = !reloadPage;
        }
    }, []); // useEffect

    const filtered = (key?: string, value?: string) => {
        const filtered: any = []
        records.filter((record: any) => {
            if (
                record.vesselEnrollment
                .toLocaleLowerCase()
                .includes(textSearch.toLocaleLowerCase()) ||
                record.vesselName
                .toLocaleLowerCase()
                .includes(textSearch.toLocaleLowerCase()) ||
                toString(record.locator)
                .toLocaleLowerCase()
                .includes(textSearch.toLocaleLowerCase())
            )
            filtered.push(record)
            return record
        })
        setRecords(filtered)
        return ''
    }

    useEffect(() => {
        if (textSearch.length >= 3) {
            filtered()
        } else if (textSearch.length < 3) {
          setRecords(originalRecords)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [textSearch]);

    function viewPage() {

        return (
            <Container fluid className="page-body delivery">
                <Row>
                    <Col md={12} className="page-sweet">
                        <Card 
                            className={styles.operation}
                            style={{ minHeight : 500 }}
                        >
                            <Card.Header>
                                <div className="card-actions d-flex justify-content-between">
                                    <div className="d-flex">
                                        <div className="card-actions-time d-flex flex-row">
                                            <DatePicker
                                                locale={ptBR}
                                                selected={toDate(dateTimeStart, 'dd/mm/yyyy HH:MM:ss')}
                                                onChange={(date: any) => onChange_DateTimeStart(date) }
                                                dateFormat="dd/MM/yyyy"
                                                customInput={<PickerButtom />}
                                                selectsStart
                                                startDate={toDate(dateTimeStart, 'dd/mm/yyyy HH:MM:ss')}
                                                endDate={toDate(dateTimeEnd, 'dd/mm/yyyy HH:MM:ss')}

                                                popperClassName="some-custom-class"
                                                popperPlacement="top-end"
                                                popperModifiers={[
                                                    {
                                                        name : "offset",
                                                        options : {
                                                            offset : [5, 10]
                                                        }
                                                    },{
                                                        name : "preventOverflow",
                                                        options : {
                                                            rootBoundary : "viewport",
                                                            tether : false,
                                                            altAxis : true
                                                        }
                                                    }
                                                ]}
                                            /> 
                                            <DatePicker
                                                locale={ptBR}
                                                selected={toDate(dateTimeEnd, 'dd/mm/yyyy HH:MM:ss')}
                                                onChange={(date: any) => onChange_DateTimeStop(date) }
                                                dateFormat="dd/MM/yyyy"
                                                customInput={<PickerButtom />}
                                                selectsEnd
                                                startDate={toDate(dateTimeStart, 'dd/mm/yyyy HH:MM:ss')}
                                                endDate={toDate(dateTimeEnd, 'dd/mm/yyyy HH:MM:ss')}
                                                minDate={toDate(dateTimeStart, 'dd/mm/yyyy HH:MM:ss')}

                                                popperClassName="some-custom-class"
                                                popperPlacement="top-end"
                                                popperModifiers={[
                                                    {
                                                        name : "offset",
                                                        options : {
                                                            offset : [5, 10]
                                                        }
                                                    },{
                                                        name : "preventOverflow",
                                                        options : {
                                                            rootBoundary : "viewport",
                                                            tether : false,
                                                            altAxis : true
                                                        }
                                                    }
                                                ]}
                                            />
                                        </div>
                                        <Button variant="secondary" className='ms-2' onClick={ (e) => onClick_RefreshDelivery(e) } disabled={sending}>
                                            { sending ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : <FaSpinner size={22} /> } {' '}
                                            {display.buttom.refresh}
                                        </Button>
                                    </div>
                                    {authService.hasPermission(PermissionEnum.OPERATION_DELIVERY_ADD) && 
                                        <ButtonMaterial size='small' variant="contained" onClick={(e) => onClick_AddRecord(e) } ><AddIcon />Pedido</ButtonMaterial>
                                    }
                                </div>
                                <Card.Title>{display.subtitle.delivery}</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <FormControl fullWidth sx={{width: 300, marginBottom: 2 }} variant="standard">
                                    <InputLabel className={styles.label} htmlFor="standard-adornment-amount">Pesquisar</InputLabel>
                                    <Input id="standard-adornment-amount"
                                        value={textSearch}
                                        onChange={(e) => setTextSearch(e.target.value)}
                                        endAdornment = {
                                            <InputAdornment position="end">
                                                <SearchIcon className='isClickable' />
                                            </InputAdornment>
                                        }
                                    />
                                    <FormHelperText id="component-helper-text">
                                        Regitro, Embarcação ou Localizador
                                    </FormHelperText>
                                </FormControl>
                                <ThemeProvider theme={theme}>
                                    <div style={{ height: 402, width: '100%', marginTop: 0 }}>
                                        <DataGrid
                                            rows={records}
                                            rowCount={recordCount}
                                            getRowId={row => row.id}
                                            loading={isLoading}
                                            columns={columns}
                                            pageSize={pageSize}
                                            onPageSizeChange={newPageSize => onChangePageSize(newPageSize)}
                                            page={page}
                                            onPageChange={newPage => onChangePage(newPage) }
                                            
                                            rowsPerPageOptions={[10, 25, 50, 75, 100]}
                                            rowHeight={70}
                                            disableSelectionOnClick
                                            // onCellClick={(e) => console.log(e)}
                                            onSelectionModelChange={(newSelectionModel: any) => {
                                                console.log('onSelectionModelChange')
                                                setSelectionModel(newSelectionModel)
                                            }}
                                            components={{
                                                Toolbar: GridToolbar,
                                                LoadingOverlay: LinearProgress
                                            }}
                                            selectionModel={selectionModel}
                                        />
                                    </div>
                                </ThemeProvider>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    } // viewPage

    return (
        <div className="page">
            <OperationHeader title={title} description={description} />
            { viewPage() }
            {showDelivery && (
                <DeliveryCadastreModal 
                    isEdit={isEditDelivery}

                    show={showDelivery}
                    recordId={deliveryId}
                    record={delivery}
                    records={records}
                    onSubmitModal={(event: any, record: any) => {
                        event.preventDefault();

                        setDelivery(record);
                        if (isEditDelivery) {
                            
                            const deliverList = originalRecords.map((deliver: any, index: number) => {
                                if (record.id === deliver.id)
                                    deliver = record;
                                return deliver;
                            });
                            setRecords(deliverList);
/*                            
                            const updatedDelivery = Array.from(records) as any;
                            for ( var idx_Edit = 0; idx_Edit < updatedDelivery.length; idx_Edit++) {
                                if (updatedDelivery[idx_Edit].id === record.id) {
                                    updatedDelivery[idx_Edit] = record;
                                }
                            }
                            setRecords(updatedDelivery);
*/
                        } else {
                            // setRecords([...records, record]);
                            console.log('Olhar este ponto')
                        }
                        setShowDelivery(false);
                        setEditDelivery(false);
                        searchFilter(dateTimeStart, dateTimeEnd);
                    }}
                    onCancelModal={(event: any) => {
                        setEditDelivery(false);
                        setShowDelivery(false);
                    }}
                />
            )}
        </div>
    );

}

export default DeliveryOperation;